import React from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import { Toggle } from '../common/Toggle';

function AccountsList({
  accNumbers,
  account,
  colorIndex,
  dataKey,
  getAccountID,
}) {
  const isChecked = includes(accNumbers, account.id);
  let accountName =
    account.metadata.display_name === null ||
    isEmpty(account.metadata.display_name)
      ? account.product.name
      : account.metadata.display_name;
  return (
    <li className={`account-list__items account-${colorIndex} ${account.type}`}>
      <h6 className="account-list__items__title">{accountName}</h6>
      <div className="account-list__items__switch toggleswitch">
        <Toggle
          aria-label="No label tag"
          id={`check_${dataKey}`}
          data-id={account.id}
          defaultChecked={isChecked}
          onChange={getAccountID}
        />
      </div>
    </li>
  );
}

AccountsList.propTypes = {
  account: PropTypes.object,
  dataKey: PropTypes.number,
  getAccountID: PropTypes.func,
  accNumbers: PropTypes.array,
  colorIndex: PropTypes.number,
};

export { AccountsList };
